// src/store/slices/feedbackSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import feedbackService from '../../services/feedbackService';

// Async thunk за изпращане на обратна връзка
export const submitFeedback = createAsyncThunk(
  'feedback/submit',
  async (feedbackData, { rejectWithValue }) => {
    try {
      // console.log('Submitting feedback to API:', feedbackData);
      const response = await feedbackService.submitFeedback(feedbackData);
      // console.log('Feedback API response:', response);
      return response.data;
    } catch (error) {
      console.error('Feedback submission error:', error);
      
      // Повече детайли за грешката
      if (error.response) {
        // Сервърът отговори с грешка
        console.error('Server error response:', error.response);
        return rejectWithValue({
          message: error.response.data?.message || 'Грешка от сървъра',
          status: error.response.status,
          data: error.response.data
        });
      } else if (error.request) {
        // Заявката беше направена, но няма отговор
        console.error('No response from server:', error.request);
        return rejectWithValue({
          message: 'Няма връзка със сървъра. Моля, проверете интернет връзката.',
          status: 0
        });
      } else {
        // Друга грешка
        console.error('Other error:', error.message);
        return rejectWithValue({
          message: error.message || 'Възникна грешка при изпращане',
          status: 500
        });
      }
    }
  }
);

const feedbackSlice = createSlice({
  name: 'feedback',
  initialState: {
    loading: false,
    error: null,
    success: false,
    submittedData: null
  },
  reducers: {
    resetFeedback: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.submittedData = null;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitFeedback.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(submitFeedback.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.submittedData = action.payload;
        state.error = null;
      })
      .addCase(submitFeedback.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || { 
          message: 'Неизвестна грешка при изпращане на обратна връзка' 
        };
      });
  }
});

export const { resetFeedback, clearError } = feedbackSlice.actions;

export const selectFeedbackLoading = (state) => state.feedback.loading;
export const selectFeedbackError = (state) => state.feedback.error;
export const selectFeedbackSuccess = (state) => state.feedback.success;

export default feedbackSlice.reducer;